"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayout = exports.Layout = exports.useHeaderContext = exports.HeaderContextProvider = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const NavItemsContextProvider_1 = require("../../nav/NavItemsContextProvider");
const Body_1 = require("./body/Body");
const Footer_1 = require("./footer/Footer");
const Header_1 = require("./header/Header");
const { NavItemsContextProvider, useNavItemsContext } = NavItemsContextProvider_1.createNavItemsContextProvider();
exports.HeaderContextProvider = NavItemsContextProvider;
function useHeaderContext() {
    return useNavItemsContext();
}
exports.useHeaderContext = useHeaderContext;
function Layout(_a) {
    var { children, header, body, footer } = _a, components = tslib_1.__rest(_a, ["children", "header", "body", "footer"]);
    const HeaderComponent = components.HeaderComponent || Header_1.Header;
    const BodyComponent = components.BodyComponent || Body_1.Body;
    const FooterComponent = components.FooterComponent || Footer_1.Footer;
    const layoutContent = (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [(body || children) && (jsx_runtime_1.jsx(BodyComponent, Object.assign({}, (body !== null && body !== void 0 ? body : {}), { children: children }), void 0)),
            footer && jsx_runtime_1.jsx(FooterComponent, Object.assign({}, footer), void 0)] }, void 0));
    if (!header) {
        return layoutContent;
    }
    return (jsx_runtime_1.jsxs(exports.HeaderContextProvider, { children: [jsx_runtime_1.jsx(HeaderComponent, Object.assign({}, header), void 0), layoutContent] }, void 0));
}
exports.Layout = Layout;
function useLayout(_a) {
    var { Component } = _a, props = tslib_1.__rest(_a, ["Component"]);
    if (!Component) {
        Component = Layout;
    }
    return jsx_runtime_1.jsx(Component, Object.assign({}, props), void 0);
}
exports.useLayout = useLayout;
//# sourceMappingURL=Layout.js.map